'use client'

import React from 'react'
import type { JSX } from 'react'
import createWidget from '@/widgets/create-widget'
import { PhotoIcon } from '@heroicons/react/24/solid'
import FacultySectionSchema, { FacultySectionProps, FacultySectionDefaultValues, Faculty } from './schema'
import FacultySection from '@/components/RevampedLanding/FacultySection'

export function FacultySectionWidget(props: Faculty) {
  const { facultySection } = props
  return <FacultySection facultySectionData={facultySection} />
}

export default createWidget<Faculty>({
  formType: FacultySectionSchema,
  render(props): JSX.Element {
    return <FacultySectionWidget {...props} />
  },
  id: 'Landing.Page.FacultySection',
  name: 'Faculty Section',
  icon: <PhotoIcon className='w-10 h-10' />,
  defaultProps: FacultySectionDefaultValues,
})
